import { h } from 'preact';
import cx from 'classnames';
import style from './style.less';
import { Icon } from '@cube/blocks';


const Icons = {
	slideshow: <Icon name="gallery-cube" class={style.icon} />,
	video: <Icon name="play-cube" class={style.icon} />,
	headline: null
};


/** A generic card icon for consistency sake
 *  @param {String} hover      whether or not the user is hovering over the icon
 *  @param {String} name       the icon name to show
 *  @param {Boolean} [color]   if false, brand primary won't be used for icon colors
 *
 *  @TODO: get slideshow icon added and use it in place of current slideshow
 */
const CardIcon = (
	({ hover, name, color, qeId, ...props }) => {
		if (!name || !Icons[name]) {
			return null;
		}
		return (
			<div
				class={cx(props.class,
					style.iconWrapper,
					style[name],
					hover && style.hover,
					!color && style.noColor)}
				qid={qeId + '-icon'}
			>
				{Icons[name]}
			</div>
		);
	}
);

export default CardIcon;
